<template>
    <div class="adjustmentReport">
        <div class="content">
            <div class='adjustBox'>
                <p class='adjustTitle'>原规划内容</p>
                <PlanReport :plan="planLast" :version='version'></PlanReport>
            </div>
            <div class='adjustBox'>
                <p class='adjustTitle'>调整规划内容</p>
                <PlanReport :plan="plan" :version="version" :professional="professional"></PlanReport>
            </div>
            <AdjustmentReport
                :targetCareer="adjustmentData.targetCareer"
                :university="adjustmentData.university"
                :further="adjustmentData.further"
                :choose="adjustmentData.choose"
                :version="version"
                :professional="professional"
            >
            </AdjustmentReport>
        </div>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.go(-1)" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>
<script>
import PlanReport from '@/components/consultant/planningContent/PlanReport.vue'
import AdjustmentReport from '@/components/consultant/planningContent/AdjustmentReport.vue'
import Button from '@/components/Button.vue'
export default {
    name: "adjustmentReport",
    components: {
        PlanReport,
        AdjustmentReport,
        Button
    },
    data() {
        return {
            adjustmentData: {
                targetCareer:null,
                university:null,
                further:null,
                choose:null,
            },
            planReportTitle: '原规划内容',
            planLast:{},
            plan:{},
            version:'',
            professional:''
            // paln: {
            //     "id": 6,
            //     "lastId": 5,
            //     "studentId": 1,
            //     "universityIdName": [{
            //         "id": 2739,
            //         "name": "清华大学美术学院"
            //     }, {
            //         "id": 1,
            //         "name": "北京大学"
            //     }, {
            //         "id": 2603,
            //         "name": "北京大学医学部"
            //     }],
            //     "score": "526",
            //     "rank": 56,
            //     "furtherWay": "综合评价录取",
            //     "furtherWayNeed": "123",
            //     "furtherWayNeedOther": "123",
            //     "furtherWayRemark": null,
            //     "targetCareerField": "自然研究型",
            //     "targetCareer": ["临床医学", "大气科学", "法医学"],
            //     "targetSubject": ["天文学研究人员", "农业科学研究人员", "生物学研究人员"],
            //     "chooseSubjectName": ["化学", "生物", "历史"],
            //     "createdAt": "2020-12-31 16:32:56",
            //     "updatedAt": "2020-12-31 16:32:56",
            //     "deletedAt": null
            // },
            // adjustmentData: {
            //     "targetCareer": {
            //         "targetCareerField": "自然研究型",
            //         "targetCareer": ["中药学（注：授予理学学士学位）", "声学", "林学"],
            //         "targetSubject": ["数学研究人员", "化学研究人员", "物理学研究人员"],
            //         "targetRemark": "咨询"
            //     },
            //     "university": {
            //         "universityIdName": [{
            //             "id": 1,
            //             "name": "北京大学"
            //         }, {
            //             "id": 2,
            //             "name": "中国人民大学"
            //         }, {
            //             "id": 66,
            //             "name": "中国社会科学院大学"
            //         }],
            //         "universityScore": [{
            //             "universityId": 1,
            //             "universityScore": [{
            //                 "universityId": 1,
            //                 "universityName": "北京大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "理工",
            //                 "year": 2019,
            //                 "batch": "本科批",
            //                 "averageScore": "687",
            //                 "provinceScore": "443",
            //                 "differenceScore": "244"
            //             }, {
            //                 "universityId": 1,
            //                 "universityName": "北京大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "文史",
            //                 "year": 2019,
            //                 "batch": "本科批",
            //                 "averageScore": "650",
            //                 "provinceScore": "503",
            //                 "differenceScore": "147"
            //             }, {
            //                 "universityId": 1,
            //                 "universityName": "北京大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "文史",
            //                 "year": 2018,
            //                 "batch": "本科批",
            //                 "averageScore": "663",
            //                 "provinceScore": "505",
            //                 "differenceScore": "158"
            //             }, {
            //                 "universityId": 1,
            //                 "universityName": "北京大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "理工",
            //                 "year": 2018,
            //                 "batch": "本科批",
            //                 "averageScore": "691",
            //                 "provinceScore": "435",
            //                 "differenceScore": "256"
            //             }],
            //             "universityName": "北京大学"
            //         }, {
            //             "universityId": 2,
            //             "universityScore": [{
            //                 "universityId": 2,
            //                 "universityName": "中国人民大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "理工",
            //                 "year": 2019,
            //                 "batch": "本科批",
            //                 "averageScore": "665",
            //                 "provinceScore": "443",
            //                 "differenceScore": "222"
            //             }, {
            //                 "universityId": 2,
            //                 "universityName": "中国人民大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "文史",
            //                 "year": 2019,
            //                 "batch": "本科批",
            //                 "averageScore": "636",
            //                 "provinceScore": "503",
            //                 "differenceScore": "133"
            //             }, {
            //                 "universityId": 2,
            //                 "universityName": "中国人民大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "文史",
            //                 "year": 2018,
            //                 "batch": "本科批",
            //                 "averageScore": "655",
            //                 "provinceScore": "505",
            //                 "differenceScore": "150"
            //             }, {
            //                 "universityId": 2,
            //                 "universityName": "中国人民大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "理工",
            //                 "year": 2018,
            //                 "batch": "本科批",
            //                 "averageScore": "674",
            //                 "provinceScore": "435",
            //                 "differenceScore": "239"
            //             }],
            //             "universityName": "中国人民大学"
            //         }, {
            //             "universityId": 66,
            //             "universityScore": [{
            //                 "universityId": 66,
            //                 "universityName": "中国社会科学院大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "理工",
            //                 "year": 2019,
            //                 "batch": "本科批",
            //                 "averageScore": "631",
            //                 "provinceScore": "443",
            //                 "differenceScore": "188"
            //             }, {
            //                 "universityId": 66,
            //                 "universityName": "中国社会科学院大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "文史",
            //                 "year": 2019,
            //                 "batch": "本科批",
            //                 "averageScore": "615",
            //                 "provinceScore": "503",
            //                 "differenceScore": "112"
            //             }, {
            //                 "universityId": 66,
            //                 "universityName": "中国社会科学院大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "理工",
            //                 "year": 2018,
            //                 "batch": "本科批",
            //                 "averageScore": "628",
            //                 "provinceScore": "435",
            //                 "differenceScore": "193"
            //             }, {
            //                 "universityId": 66,
            //                 "universityName": "中国社会科学院大学",
            //                 "code": null,
            //                 "province": "山东",
            //                 "artsAndScience": "文史",
            //                 "year": 2018,
            //                 "batch": "本科批",
            //                 "averageScore": "636",
            //                 "provinceScore": "505",
            //                 "differenceScore": "131"
            //             }],
            //             "universityName": "中国社会科学院大学"
            //         }],
            //         "score": "156",
            //         "rank": 323,
            //         "remarkLog": "咨询记录"
            //     },
            //     "further": {
            //         "furtherWay": "国家专项计划",
            //         "furtherWayNeed": "仨范围",
            //         "furtherWayNeedOther": "违反我符文",
            //         "furtherWayRemark": "而我分为"
            //     },
            //     "choose": {
            //         "chooseSubjectRequire": [{
            //             "subject": "数学研究人员",
            //             "list": [{
            //                 "school": "北京大学",
            //                 "require": "问问问问"
            //             }, {
            //                 "school": "中国人民大学",
            //                 "require": "温热仍未"
            //             }, {
            //                 "school": "中国社会科学院大学",
            //                 "require": "玩儿我"
            //             }]
            //         }, {
            //             "subject": "化学研究人员",
            //             "list": [{
            //                 "school": "北京大学",
            //                 "require": "我认为人"
            //             }, {
            //                 "school": "中国人民大学",
            //                 "require": "温热为"
            //             }, {
            //                 "school": "中国社会科学院大学",
            //                 "require": "沃尔沃二"
            //             }]
            //         }, {
            //             "subject": "物理学研究人员",
            //             "list": [{
            //                 "school": "北京大学",
            //                 "require": "玩儿问问"
            //             }, {
            //                 "school": "中国人民大学",
            //                 "require": "玩儿温热"
            //             }, {
            //                 "school": "中国社会科学院大学",
            //                 "require": "沃尔沃二"
            //             }]
            //         }],
            //         "chooseSubjectName": ["历史", "地理", "政治"],
            //         "chooseSubjectRemark": "分文未范围"
            //     }
            // }
        }
    },
    methods: {
        adjustPlanCompared(){
            let studentId = this.studentId;
            let oldId = this.$route.query.lastId;
            let newId = this.$route.query.id;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.adjustPlanCompared, {
                studentId: studentId,
                oldId: oldId,
                newId:newId
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.adjustmentData = res.data.data;
                    this.professional = res.data.data.targetCareer.professional
                    console.log(this.professional,'版本号')
                }
            })
        },
        getPlanById(id){
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getPlanById, {
                studentId: studentId,
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.plan = res.data.data;
                    this.version = res.data.data.version
                }
            })
        },
        getPlanByIdLast(id){
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getPlanById, {
                studentId: studentId,
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.planLast = res.data.data;
                }
            })
        },
    },
    created() {
        this.getPlanByIdLast(this.$route.query.lastId);
        this.getPlanById(this.$route.query.id);
        this.adjustPlanCompared();
    }
}
</script>

<style scoped lang="less">
.adjustmentReport {

    .content {
        padding: 25px 30px;
        background-color: #fff;
    }
    .adjustTitle {
        font-size: 22px;
        font-weight: 500;
        color: #12A1F0;
        line-height: 50px;
        //margin-bottom: 20px;
    }
}
</style>